import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BadgeCheckIcon, PackageCheckIcon, PercentIcon, TruckIcon } from 'lucide-react';
import { showcaseTiles, trustLine } from '../../data/home';
const trustIcons = [BadgeCheckIcon, PackageCheckIcon, TruckIcon];
export function CategoryShowcase() {
  return <section aria-labelledby="showcase-heading" className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8 lg:pt-16" data-id="element-93" data-mp="zy43gcy2p6qp">
      <h2 id="showcase-heading" className="sr-only" data-id="element-94" data-mp="2dhteso32xc7">
        Shop per categorie
      </h2>

      {/* Trust line between hairlines */}
      <div className="flex items-center gap-6" data-id="element-95" data-mp="c9umbobt175w">
        <span className="hidden h-px flex-1 bg-line lg:block" aria-hidden="true" data-id="element-96" data-mp="c92r4em4dbg5" />
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm text-ink" data-id="element-97" data-mp="h1meg3alzky5">
          {trustLine.map((t, i) => {
          const Icon = trustIcons[i];
          return <li key={t.highlight} className="flex items-center gap-2 whitespace-nowrap" data-id="element-98" data-mp="3komfaz7xo3oc" data-mpi={i}>
                <Icon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-99" data-mp="pwd3hog9a6se" />
                <span data-id="element-100" data-mp="kxa7eti97awk">
                  {t.lead} <span className="font-bold text-success" data-id="element-101" data-mp="ky1u1etvhyap">{t.highlight}</span> {t.tail}
                </span>
              </li>;
        })}
        </ul>
        <span className="hidden h-px flex-1 bg-line lg:block" aria-hidden="true" data-id="element-102" data-mp="b7gt3kqq8hom" />
      </div>

      <ul className="mt-8 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-5" data-id="element-103" data-mp="75c44zb8498b">
        {showcaseTiles.map(t => {
        const isDeals = t.kind === 'deals';
        const isBundle = t.kind === 'bundle';
        return <li key={t.id} data-id="element-104" data-mp="3tdlfvss7sefq">
              <Link to={t.href} className={`group relative flex aspect-[4/5] flex-col overflow-hidden rounded-2xl ${isDeals ? 'bg-ink' : 'bg-[#EDEFEE]'}`} data-id="element-105" data-mp="3tewj9rhqzk6b">
                {/* Full-bleed product shot — backdrop is part of the photo, so every tile matches */}
                {!isDeals && <img src={t.image} alt="" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-106" data-mp="3h22kuvpmm1u7" />}

                {isDeals && <span className="absolute inset-0 flex items-center justify-center" aria-hidden="true" data-id="element-107" data-mp="3c2ycg7aj084x">
                    <PercentIcon className="h-1/2 w-1/2 text-volt transition-transform duration-300 ease-out group-hover:scale-105" strokeWidth={2.25} data-id="element-108" data-mp="3n66bgdqfkeo" />
                  </span>}

                {/* Title sits in the empty top band of the photo */}
                <div className="relative p-4 sm:p-6" data-id="element-109" data-mp="3uso8sytxt1yy">
                  <p className={`truncate text-xs font-medium sm:text-sm ${isDeals ? 'text-volt' : isBundle ? 'font-semibold text-success' : 'text-muted'}`} data-id="element-110" data-mp="2fdgw8ydx33oz">
                    {t.eyebrow}
                  </p>
                  <h3 className={`mt-0.5 text-lg font-bold leading-tight tracking-tight [hyphens:manual] sm:text-2xl ${isDeals ? 'text-white' : 'text-ink'}`} data-id="element-111" data-mp="26wgn0yksfsl9">
                    {t.title}
                  </h3>
                  {isBundle && <span className="mt-2 inline-block rounded-md bg-success px-2 py-0.5 text-[11px] font-bold text-white" data-id="element-112" data-mp="1t5v1f23y94jo">
                      Extra voordeel
                    </span>}
                </div>

                {/* Footer pill keeps price + arrow legible on any photo */}
                <div className="relative mt-auto p-3 sm:p-4" data-id="element-113" data-mp="1y2v556dbtv7m">
                  <span className={`flex items-center justify-between gap-2 rounded-full py-1.5 pl-4 pr-1.5 backdrop-blur ${isDeals ? 'bg-white/10' : 'bg-white/85'}`} data-id="element-114" data-mp="1ae27n5h23faw">
                    <span className={`truncate text-xs font-semibold sm:text-sm ${isDeals ? 'text-white' : isBundle ? 'text-success' : 'text-ink'}`} data-id="element-115" data-mp="8pf521a02wv1">
                      {t.note}
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-150 sm:h-9 sm:w-9 ${isDeals ? 'bg-volt text-ink group-hover:bg-volt-hover' : 'bg-ink text-white group-hover:bg-volt group-hover:text-ink'}`} aria-hidden="true" data-id="element-116" data-mp="mgtkjy4p8fxc">
                      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-117" data-mp="15dl4m9s2ez2g" />
                    </span>
                  </span>
                </div>
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}